import React from "react";
import { useEffect, useMemo, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";

export const FormCategoriaProducto = ({ objeto=null, hideModalEvento, categorias, postCategoriaProducto }) => {

  const inputRules = {
    categoria: {
      required: {
        value: true,
        message: "Campo requerido",
      },
      maxLength: {
        value: 200,
        message: "Máximo de 200 caracteres",
      },
    },
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: useMemo(() => {
      return objeto;
    }, [objeto]),
  });

  const onSubmit = (data) => {
    postCategoriaProducto(data)
  };

  return (
    <form id="FormCategoriaProducto" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-fluid formgrid grid pt-2">
                  <div className="field col-12">
                      <label htmlFor="categoria">Categoria</label>
                      <Controller
                          name="categoria"
                          control={control}
                          defaultValue=""
                          rules={inputRules.categoria}
                          options={categorias}
                          render={({ field }) => (
                              <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.categoria })} 
                              onChange={(e) => field.onChange(e.target.value.toUpperCase())}
                              rows={1} cols={30} autoResize />
                          )}
                      />
                      {errors?.categoria && <small className="p-error">{errors.categoria.message}</small>}
                </div>
          </div>
    </form>
  );
};

export default FormCategoriaProducto;
